import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]



export default /*#__PURE__*/_defineComponent({
  props: ['src', 'height'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    placement: "top",
    effect: "light",
    "hide-after": 100
  }, {
    content: _withCtx(() => [
      _createElementVNode("img", {
        referrerPolicy: "no-referrer",
        style: _normalizeStyle({ height: __props.height || 'auto' }),
        src: __props.src,
        alt: ""
      }, null, 12, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("img", {
        referrerPolicy: "no-referrer",
        class: _normalizeClass(_ctx.$attrs.class),
        src: __props.src,
        alt: ""
      }, null, 10, _hoisted_2)
    ]),
    _: 1
  }))
}
}

})